import { useTranslation } from "react-i18next";

export default function HelpPage() {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-3xl mx-auto mt-6 text-gray-700 px-2 jandi-guidance-page">
      <div className="bg-white shadow-sm rounded-2xl p-6 leading-relaxed border jandi-guidance-content">
        <h1 className="jandi-guidance-title text-gray-800 mb-4" style={{ fontSize: '26px' }}>
          {t("helpTitle")}
        </h1>
        <p className="mb-4" style={{ whiteSpace: "pre-line" }}>
          {t("helpIntro")}
        </p>
        <p className="jandi-guidance-title font-semibold text-gray-800 mb-2" style={{ fontSize: '18px' }}>{t("helpSupportTitle")}</p>
        <p className="mb-1">
          {t("helpEmail")}{" "}
          <a
            href="mailto:hola@jandipr.com"
            className="text-[#4285F4] underline"
          >
            hola@jandipr.com
          </a>
        </p>
        <p className="mb-4">
          {t("helpPhone")}{" "}
          <a
            href="tel:787-436-6326"
            className="text-[#4285F4] underline"
          >
            787-436-6326
          </a>
        </p>
        <p className="mb-4" style={{ whiteSpace: "pre-line" }}>
          {t("helpDisputes")}
        </p>
        <p className="mb-2" style={{ whiteSpace: "pre-line" }}>
          {t("helpMore")}
        </p>
        <p>
          <a
            href="https://www.jandipr.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#4285F4] underline"
          >
            www.jandipr.com
          </a>
        </p>
      </div>
    </div>
  );
}
